// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_iz-1";
export var quotedThread = "_iz-0";